import { render } from "./company-system-overview.vue?vue&type=template&id=64af437c&ts=true"
import script from "./company-system-overview.vue?vue&type=script&lang=ts"
export * from "./company-system-overview.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__